import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import userStore from '../../store/userStore';
import AIAgentReview from '../AIAgentPage/components/AIAgentReview';
import ArHistory from './ArHistory';
import HelpTip from '../../components/HelpTip';

/**
 * La revisión de la IA del cliente: lo que el agente propone para los
 * expedientes AR de su empresa, con «Aprobar» y «Lo hago yo». Es la misma cola
 * que la del admin, contra `/ar-review`; el servidor decide qué entra.
 *
 * Solo company y gestor. Si la empresa no tiene AR activado, el servidor dice
 * que no y el menú ni siquiera enseña la entrada.
 * Ver docs/ar-revision-por-fase-plan.md.
 */
const ROLES = ['company', 'gestor'];

function ArReviewPage() {
  const { user } = userStore();
  // «Pendientes» es lo que espera; «Historial», todo lo que ya decidió el agente
  // (docs/ar-ia-historial-plan.md).
  const [vista, setVista] = useState('pendientes');

  if (!ROLES.includes(user?.role)) {
    return <Navigate to='/dashboard' replace />;
  }

  return (
    <MainLayout>
      <div className='space-y-4'>
        <header className='bg-white border border-slate-200 rounded-lg px-5 py-4'>
          <h1 className='text-2xl font-semibold text-slate-900 inline-flex items-center gap-2'>
            Revisión de la IA
            <HelpTip title='¿Qué pasa si nadie revisa?'>
              Mientras una propuesta está pendiente, ese expediente espera: no sale nada más, tampoco los avisos
              programados. Así no se le manda al deudor algo que ya no toca. Revisa a diario.
            </HelpTip>
          </h1>
          <p className='text-sm text-slate-500 mt-1'>
            Lo que el agente propone para vuestros expedientes AR. Apruébalo para que salga, o pulsa «Lo hago yo» y
            hazlo tú desde aquí.
          </p>
          <p className='text-xs text-slate-500 mt-1'>
            Qué se revisa y qué sale solo lo decide la empresa en Configuración.
          </p>
        </header>
        <div className='inline-flex rounded-lg border border-slate-200 bg-white p-1' role='tablist'>
          {[
            { id: 'pendientes', label: 'Pendientes' },
            { id: 'historial', label: 'Historial' },
          ].map(t => (
            <button
              key={t.id}
              type='button'
              role='tab'
              aria-selected={vista === t.id}
              onClick={() => setVista(t.id)}
              className={`px-3 py-1.5 rounded-lg text-sm font-medium ${
                vista === t.id ? 'bg-indigo-600 text-white' : 'text-slate-600 hover:bg-slate-50'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
        {vista === 'pendientes' ? <AIAgentReview basePath='/ar-review' showSettings={false} clienteAr /> : <ArHistory />}
      </div>
    </MainLayout>
  );
}

export default ArReviewPage;
